import React from 'react';
import { Select, Radio } from 'antd';

const { Option }= Select;

const getMatchOption =  (list, prop, value) => {
    return ((list || []).find(i => i[prop] == value) || {});
};

const convertOption = (value, label) => item => ({value: item[value], label: item[label]});

function generateOptions(data, type) {
    const keys = Object.keys(data);
    if (type === 'radio') {
        return keys.map(i => <Radio key={i} value={i}>{ data[i] }</Radio>);
    } else {
        return keys.map(i => <Option key={i} value={i}>{ data[i] }</Option>);
    }
};

export { convertOption, generateOptions, getMatchOption };


// WEBPACK FOOTER //
// ./src/components/shared/selectFn.js